import { Input, Toast } from "../components";
import { validateEmail, setupValue } from "../commons";
import { Link, useNavigate } from "react-router-dom";
import { urlApi, register, urlHome } from "../constants";
import { logo, login, arrowLeft, sidePanel } from "../assets";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailValidation, setEmailValidation] = useState(true);
  const [wrongCredentials, setWrongCredentials] = useState(false);
  const [textCredentials, setTextCredentials] = useState("Wrong Credentials");
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [pass, setPass] = useState("");
  const handleOnClick = (event) => {
    event.preventDefault();
    if (emailValidation) {
      setLoading(true);
      fetch(urlApi + "/v1/auth/login", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        body: JSON.stringify({
          email: email,
          password: pass,
        }),
      })
        .then((res) => {
          if (res.status == 403) {
            const data = {
              data: null,
              is_confirmed: true,
            };
            return data;
          }
          return res.json();
        })
        .then((data) => {
          if (data.data !== null && data.data !== undefined) {
            localStorage.setItem("user_info", JSON.stringify(data.data));
            navigate("/");
          } else if (data.data == null && data.is_confirmed !== undefined) {
            setLoading(false);
            toast.error("Your email is not verified", {
              position: "top-center",
              autoClose: 3000,
            });
          } else {
            setLoading(false);
            toast.error("Missmatch credentials", {
              position: "top-center",
              autoClose: 3000,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          setTextCredentials("Something went wrong, try again!");
        });
    }
  };
  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-center">
      <ToastContainer />
      <div className="flex flex-row w-full">
        <div className="flex flex-col bg-white justify-center items-center md:w-2/3 w-full">
          <img
            src={logo}
            className="w-[130px] md:w-[20%] md:max-w-[130px] mb-8"
          />
          <div className="mb-10 font-semibold text-[28px]">Sign In</div>
          <div className="flex flex-col border text-black justify-center items-center shadow-lg rounded-lg font-rubik w-[70%] sm:max-w-[400px]">
            <div className="flex flex-col w-[90%] py-3">
              <div className="divide-y">
                <form className="flex flex-col justify-center space-y-3 mb-3">
                  <div></div>
                  <div className="flex flex-col">
                    <Input
                      id={"email"}
                      type={"email"}
                      req={true}
                      onBlurfunc={(e) => validateEmail(e, setEmailValidation)}
                      onChangefunc={(e) =>
                        setupValue(e, setEmail, setEmailValidation)
                      }
                      error={emailValidation}
                      value={email}
                    />
                    <span className="text-[10px] md:text-[12px] text-red-400">
                      {!emailValidation ? register.email.error : null}
                    </span>
                  </div>
                  <div className="flex flex-col">
                    <Input
                      id={"password"}
                      error={true}
                      type={visible ? "text" : "password"}
                      req={true}
                      value={pass}
                      onChangefunc={(e) => setupValue(e, setPass, () => null)}
                      showIcon={true}
                      stateIcon={visible}
                      setStateIcon={setVisible}
                    />
                    <div className="flex flex-col w-full justify-center items-center mt-2">
                      <Link
                        className="text-blue-400 text-[12px] md:text-[14px] hover:underline"
                        to="/forgot"
                      >
                        Forgot Password?
                      </Link>
                    </div>
                  </div>
                  <div className="flex flex-row mt-5 mb-3">
                    <button
                      type="submit"
                      onClick={handleOnClick}
                      className={`text-white py-2 px-2 ${
                        !Boolean(
                          emailValidation & (email != "") & (pass.length > 4)
                        )
                          ? "bg-[#667085] bg-opacity-20"
                          : "bg-primary"
                      } rounded-md w-full justify-center items-center flex flex-col
                    ${
                      !Boolean(
                        emailValidation & (email != "") & (pass.length > 4)
                      ) | loading
                        ? ""
                        : "hover:bg-tertiary"
                    }
                    `}
                      disabled={
                        !Boolean(
                          emailValidation & (email != "") & (pass.length > 4)
                        ) | loading
                      }
                    >
                      {loading ? (
                        <div role="status">
                          <svg
                            aria-hidden="true"
                            className="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-secondary"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="white"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="#E47410"
                            />
                          </svg>
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        <p className="font-base tracking-wider text-[14px] md:text-[16px]">
                          Sign In
                        </p>
                      )}
                    </button>
                  </div>
                </form>
                <div className="flex flex-col text-black justify-center items-center">
                  <div className="text-black text-[12px] md:text-[14px] mt-2 py-2">
                    Doesn't have an account?{" "}
                    <Link
                      className="text-blue-400 hover:underline"
                      to="/register"
                    >
                      Sign Up
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-[12px] font-bold font-nitomeyo text-gray-500 mt-10">
            Use your dekstop for better experience
          </div>
        </div>
        <div className="hidden md:flex flex-col md:w-1/3">
          <img src={sidePanel} alt="nitomeyo puzzles" className="h-full" />
        </div>
      </div>
    </div>
  );
}

export default Login;
